import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

// v1 ships the Suppliers tab only; Assets/Parts land later once the backend materializes them.
const TABS = [{ key: 'suppliers', name: 'Suppliers' }];

const RequestsToAddOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/buyer/requestsToAdd/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => history.location.pathname.indexOf(key) !== -1,
		[history.location.pathname]
	);

	return (
		<>
			<Route
				path="/buyer/requestsToAdd/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/buyer/requestsToAdd/overview/suppliers',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Requests to Add"
				tabs={TABS}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="requestsToAddPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(RequestsToAddOverviewPage)
);
